module.exports = __webpack_public_path__ + "img/selected7-min.8c093454.png";